export const macOSCheck = () => {
  if (typeof navigator !== "undefined") {
    return /Mac/.test(navigator.platform);
  }
  return false;
};
